module.exports = __webpack_public_path__ + "img/index-2.6ffafd4d.png";